import {imagesPost} from "../api/images/imagesPost.ts";
import {arrayBufferToBase64, isArrayBuffer} from "../utils/arrayBuffer.ts";
import {getBase64FromUpload} from "../utils/getBase64FromUpload.ts";

export const uploadImage = async (image?: { originFileObj: File }[]) => {
    const imageFileObj = image?.[0]?.originFileObj;
    if(!imageFileObj) {
        return;
    }

    let imageBuf = await getBase64FromUpload(imageFileObj);
    if(isArrayBuffer(imageBuf)) imageBuf = arrayBufferToBase64(imageBuf);
    const imageMime = imageFileObj.type;
    return (await imagesPost(imageMime, imageBuf!.split(',')[1])).payload.id;
}